import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput as Checkbox, BaseTextInput as InputText } from '@capsicum/common-web';
import { useAmlSourceOfIncome } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';

export const SourceOfIncome = () => {
	const { $t } = useIntl();
	const { checkboxData, handleCheckbox, handleInput, isOtherSelected } = useAmlSourceOfIncome();

	return (
		<S.Wrapper>
			<S.Question>{$t('amlQuestionnaire.fourthStep.updatedQuestion')}</S.Question>
			<S.QuestionSubtitle>{$t('amlQuestionnaire.questionSubtitle')}</S.QuestionSubtitle>
			<S.CheckboxesContainer>
				{checkboxData.map((item, index) => (
					<Checkbox
						key={index}
						testID={`aml-questionnaire-source-of-income-checkbox${index + 1}`}
						onChange={e => handleCheckbox(e, item.value)}
					>
						<S.CheckboxText>{item.label}</S.CheckboxText>
					</Checkbox>
				))}
			</S.CheckboxesContainer>
			{isOtherSelected && (
				<InputText
					label={$t('amlQuestionnaire.fourthStep.sourceOfIncome')}
					testID="aml-questionnaire-source-of-income-other-input-text"
					onChange={e => handleInput(e.target.value)}
				/>
			)}
		</S.Wrapper>
	);
};
